// extracted by mini-css-extract-plugin
export default {"socialBtn":"SocialButton_socialBtn__fw9OU","socialText":"SocialButton_socialText__2tjVA","socialIcon":"SocialButton_socialIcon__bGdkp","lastUsed":"SocialButton_lastUsed__gTjFW"};